import { translateFr as tfr } from "@/i18n";
import { dateLocale } from "@/lib/utils";
export const HEALTH = {
  NORMAL: { label: "Suivi normal", chip: "bg-success/10 text-success border-success/30", dot: "bg-success" },
  ATTENTION: { label: "Attention", chip: "bg-warning/10 text-warning border-warning/30", dot: "bg-warning" },
  ACTION_REQUIRED: { label: "Action requise", chip: "bg-athlynx/10 text-athlynx border-athlynx/30", dot: "bg-athlynx" },
};

export const PLACEMENT_STATUS = {
  ACTIVE: "Actif",
  COMPLETED: tfr("Terminé"),
  TERMINATED: tfr("Résilié"),
  TRANSFERRED: "Transfert",
  ARCHIVED: tfr("Archivé"),
};

export const TRISTATE = [
  { id: "positive", label: "Positive", cls: "bg-success/10 text-success border-success/30" },
  { id: "stable", label: "Stable", cls: "bg-info/10 text-info border-info/30" },
  { id: "watch", label: tfr("À surveiller"), cls: "bg-warning/10 text-warning border-warning/30" },
];

export const CLOSE_REASONS = [
  { id: "contract_ended", label: tfr("Contrat terminé") },
  { id: "transfer", label: "Transfert" },
  { id: "termination", label: tfr("Résiliation") },
  { id: "new_opportunity", label: tfr("Nouvelle opportunité") },
  { id: "other", label: "Autre" },
];

export const triLabel = (v) => TRISTATE.find((t) => t.id === v)?.label || null;
export const triCls = (v) => TRISTATE.find((t) => t.id === v)?.cls || "";

export function daysUntil(iso) {
  if (!iso) return null;
  const d = new Date(String(iso).slice(0, 10) + "T00:00:00");
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return Math.round((d - today) / 864e5);
}

export function fmtDateFr(iso, locale) {
  if (!iso) return "—";
  try { return new Date(String(iso).slice(0, 10) + "T00:00:00").toLocaleDateString(locale || dateLocale(), { day: "numeric", month: "short", year: "numeric" }); }
  catch { return iso; }
}

export function relAgo(iso) {
  const d = daysUntil(iso);
  if (d === null) return null;
  const en = (() => { try { return localStorage.getItem("athlynx_lang") === "en"; } catch { return false; } })();
  if (d === 0) return tfr("Aujourd'hui");
  if (d > 0) return d === 1 ? tfr("Demain") : `${tfr("Dans")} ${d} ${tfr("jours")}`;
  const a = Math.abs(d);
  if (a < 31) return en ? `${a} ${a > 1 ? "days" : "day"} ago` : `Il y a ${a} jour${a > 1 ? "s" : ""}`;
  const m = Math.round(a / 30.44);
  return en ? `${m} ${m > 1 ? "months" : "month"} ago` : `Il y a ${m} mois`;
}

export function monthsLeft(iso) {
  const d = daysUntil(iso);
  if (d === null || d < 0) return null;
  return Math.round(d / 30.44);
}
